export const numberFormatePrice = (price: number) => {
    // no comma separator use point
    return new Intl.NumberFormat('th-TH', { style: 'decimal' }).format(price);
};

export const telephoneFormate = (telephone: string) => {
    return telephone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}
